<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.paymententry') }}
            <template v-if="ready">
              >
              {{ payment.pe_code }}
            </template>
          </div>
        </div>
        <div class="col-md-8 right">
          <div
            v-if="ready"
            class="action">

            <div
              v-if="showOptionButton"
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary shake"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-cog"/>
                <span class="name">{{ $t('button.options') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  v-if="hasRoleDelete"
                  class="dropdown-item"
                  @click="openConfirmdeleteModal()">
                  <i class="fas fa-trash text-danger"/>
                  <span class="text-danger">{{ $t('button.delete') }}</span>
                </a>
              </div>
            </div>
            <div
              class="dropdown item">
              <button
                id="dropdownMenuButton"
                class="btn no-bg dropdown-toggle text-secondary"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-download"/>
                <span class="name">{{ $t('button.download') }}</span>
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="dropdownMenuButton">
                <a
                  class="dropdown-item"
                  @click="downloadPdf()">
                  <span class="text-secondary">{{ $t('message.filename', { string: 'PDF' }) }}</span>
                </a>
              </div>
            </div>
            <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button">
                <i class="fas fa-envelope"></i>
                <span class="name">{{ $t('button.sendemail') }}</span>
              </button>
            </div> -->
            <!-- <div class="dropdown nodro item">
              <button class="btn no-bg text-secondary" type="button" @click="openShareLinkModal()">
                <i class="fas fa-link"></i>
                <span class="name">{{ $t('button.sharelink') }}</span>
              </button>
            </div> -->
            <div
              class="dropdown nodro item">
              <button
                class="btn no-bg text-secondary"
                type="button"
                @click="openPrintModal()">
                <i class="fas fa-print"/>
                <span class="name">{{ $t('button.print') }}</span>
              </button>
            </div>

            <!-- status -->
            <template>
              <!-- status button -->
              <div
                v-if="payment.status == 'padding' && hasRoleEdit"
                class="dropdown item">
                <button
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.pe.unpaid') }}</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    v-if="payment.status == 'padding'"
                    class="dropdown-item"
                    @click="updatePaymentStatus({ pe_id: payment.pe_id, status: 'paid' })">
                    <i
                      class="far fa-check-circle text-success"
                      style="position: relative; left: -7px;"/>
                    <span class="text-success">{{ $t('status.pe.paid') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <div
                v-else
                class="dropdown nodro item">
                <template>
                  <span
                    v-if="getPaymentStatus(payment, $t).status == 'padding'"
                    class="text-info">
                    {{ getPaymentStatus(payment, $t).message }}
                  </span>
                  <span
                    v-if="getPaymentStatus(payment, $t).status == 'completed'"
                    class="text-success">
                    {{ getPaymentStatus(payment, $t).message }}
                  </span>
                  <span
                    v-else-if="getPaymentStatus(payment, $t).status == 'uncompleted'"
                    class="text-info">
                    {{ getPaymentStatus(payment, $t).message }}
                  </span>
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <WrapperDoc>
          <template #form>
            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.typeofpaymententry')"
                  :subtitle="$t('series.pe') + ' ' + payment.pe_code"/>
                <div class="form-row mt-3">
                  <div class="col-md-6">
                    <div class="col-12 row no-margin no-padding">
                      <vs-radio
                        :disabled="true"
                        v-model="formType"
                        style="float: left;padding: 0;"
                        color="#A3CA76"
                        vsValue="pay">
                        <strong>{{ $t('message.checkboxexpense') }}</strong>
                      </vs-radio>
                    </div>
                    <div
                      class="form-check-label"
                      style="margin-left: 25px;">
                      <p>{{ $t('message.checkboxexpensedetails') }}</p>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="col-12 row no-margin no-padding">
                      <vs-radio
                        :disabled="true"
                        v-model="formType"
                        style="float: left;padding: 0;"
                        color="#A3CA76"
                        vsValue="receive">
                        <strong>{{ $t('message.checkboxreceive') }}</strong>
                      </vs-radio>
                    </div>
                    <div
                      class="form-check-label"
                      style="margin-left: 25px;">
                      <p>{{ $t('message.checkboxreceivedetails') }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section class="mb-3">
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.reference')"/>
                <div class="form-row">
                  <div class="col-4">
                    <label>{{ $t('message.type') }}</label>
                    <select
                      :class="[bindClass.doc_type]"
                      :disabled="true"
                      class="form-control custom-select">
                      <option
                        v-if="getDocInfo(payment).type == 'po'"
                        value="po"
                        selected>{{ $t('documents.po') }} / PO-
                      </option>
                      <option
                        v-if="getDocInfo(payment).type == 'ex'"
                        value="ex"
                        selected>{{ $t('documents.ex') }} / EX-
                      </option>
                      <option
                        v-if="getDocInfo(payment).type == 'in'"
                        value="in"
                        selected>{{ $t('documents.in') }} / INV-
                      </option>
                      <option
                        v-if="getDocInfo(payment).type == 'prl'"
                        value="in"
                        selected>{{ $t('documents.prl') }} / PRL-
                      </option>
                    </select>
                  </div>
                  <div
                    v-if="form.doc_type != ''"
                    class="col-8"
                    style="position: relative;">
                    <i
                      v-if="loadingPO || loadingIN || loadingEX || loadingPRL"
                      class="fas fa-spinner spin"
                      style="position: absolute; top: 34px; right: 36px;"/>
                    <template>
                      <label>{{ $t('message.series') }}</label>
                    </template>
                    <select
                      :class="[bindClass.doc_series]"
                      :disabled="true"
                      class="form-control custom-select">
                      <option>{{ getDocInfo(payment).code }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </section>

            <section
              v-if="form.doc_type != '' && form.doc_series != ''"
              class="mb-3">
              <div class="col-md-12 no-padding">
                <section-header :title="sectionHeaderRefCode"/>
                <div class="form-row mt-2">
                  <template>
                    <div
                      v-if="partnerInfo.vendor !== undefined"
                      class="col-4">
                      <label>{{ $t('message.vendor') }}</label>
                      <input
                        :disabled="true"
                        :value="partnerInfo.vendor ? partnerInfo.vendor.vendor_name : ''"
                        type="text"
                        class="form-control">
                    </div>
                    <div
                      v-if="partnerInfo.customer !== undefined"
                      class="col-4">
                      <label>{{ $t('message.customer') }}</label>
                      <input
                        :disabled="true"
                        :value="partnerInfo.customer ? partnerInfo.customer.customer_name : ''"
                        type="text"
                        class="form-control">
                    </div>
                  </template>
                  <div class="col-4">
                    <label>{{ $t('message.debttotal') }}</label>
                    <template>
                      <input
                        v-if="docInfo.po"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getDebtPurchaseAmount(docInfo.po))"
                        type="text"
                        class="form-control text-info">
                      <input
                        v-if="docInfo.in"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getDebtInvoiceAmount(docInfo.in))"
                        type="text"
                        class="form-control text-info">
                      <input
                        v-if="docInfo.ex"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getDebtExpenseAmount(docInfo.ex))"
                        type="text"
                        class="form-control text-info">
                      <input
                        v-if="docInfo.prl"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getDebtPayslipAmount(docInfo.prl))"
                        type="text"
                        class="form-control text-info">
                    </template>
                  </div>
                  <div
                    :class="{ 'col-md-2': (!docInfo.ex || !docInfo.prl), 'col-md-4': (docInfo.ex || docInfo.prl) }">
                    <label>{{ $t('message.paidtotal') }}</label>
                    <template>
                      <input
                        v-if="docInfo.po"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getPaidAmount(docInfo.po.reference.payments))"
                        type="text"
                        class="form-control">
                      <input
                        v-if="docInfo.in"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getPaidAmount(docInfo.in.reference.payments))"
                        type="text"
                        class="form-control">
                      <input
                        v-if="docInfo.ex"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getPaidAmount(docInfo.ex.reference.payments))"
                        type="text"
                        class="form-control">
                      <input
                        v-if="docInfo.prl"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(docInfo.prl.net - docInfo.prl.process.debit)"
                        type="text"
                        class="form-control">
                    </template>
                  </div>
                  <div
                    :class="{ 'col-md-2': (!docInfo.ex || !docInfo.prl), 'col-md-4': (docInfo.ex || docInfo.prl) }">
                    <label>{{ $t('message.grandtotal') }}</label>
                    <template>
                      <input
                        v-if="docInfo.po"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getTotal(docInfo.po.orders).payment)"
                        type="text"
                        class="form-control">
                      <input
                        v-if="docInfo.in"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(getTotal(docInfo.in.orders).payment)"
                        type="text"
                        class="form-control">
                      <input
                        v-if="docInfo.ex"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(docInfo.ex.payment.amount)"
                        type="text"
                        class="form-control">
                      <input
                        v-if="docInfo.prl"
                        :disabled="true"
                        :value="setToCustomDigitsNumber(docInfo.prl.net)"
                        type="text"
                        class="form-control">
                    </template>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.infopayment')"/>
                <div class="form-row mb-2">
                  <div class="col-md-4">
                    <label>{{ $t('message.type') }}</label>
                    <select
                      v-model="form.payment_type"
                      :disabled="disabledForm"
                      class="form-control custom-select">
                      <option value="cash">{{ $t('message.cash') }}</option>
                      <option value="card">{{ $t('message.creditcard') }}</option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label>{{ $t('message.paidamount', { string: currency }) }}</label>
                    <input
                      :class="[bindClass.payment_amount]"
                      v-model="form.payment_amount"
                      :disabled="disabledForm"
                      type="text"
                      class="form-control number-only text-select-all"
                      @keypress="numberOnly"
                      @keyup="form.payment_amount = setToValidNumber(form.payment_amount)"
                      @blur="form.payment_amount = setToCustomDigitsNumber(form.payment_amount)">
                  </div>
                  <div class="col-md-4">
                    <label>{{ $t('message.postingpaiddate') }}</label>
                    <BaseInputDatePicker
                      v-model="form.payment_date"
                      :disabled="disabledForm"
                    />
                  </div>
                </div>

                <div class="form-row mb-3">
                  <div class="col-12">
                    <label>{{ $t('message.note') }}</label>
                    <textarea
                      :placeholder="$t('placeholder.dotted')"
                      v-model="form.note"
                      :disabled="disabledForm"
                      class="form-control form-control-sm"
                      style="min-height: 90px;" />
                  </div>
                </div>
                <!-- <div class="form-row">
              <div class="col-12">
                <vs-checkbox color="#A3CA76"
                             style="float: left;position: relative;top: 0;left: -5px;"
                             v-model="form.ispaid">
                  {{ $t('message.ispaid') }}
                </vs-checkbox>
              </div>
            </div> -->
              </div>
            </section>
            <section
              v-if="!disabledForm"
              class="action-bar"
            >
              <template>
                <div
                  v-if="!$store.state.app.loading"
                  class="col-md-12 text-right">
                  <button
                    class="btn btn-web"
                    @click="update()">{{ $t('button.save') }}</button>
                </div>
                <div
                  v-else
                  class="col-md-12 text-right">
                  <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
                  <button
                    class="btn btn-web btn-block-mobile-only"
                    disabled><i class="fas fa-spinner spin"/></button>
                </div>
              </template>
            </section>
          </template>
          <template #ref>
            <DocRef
              :refDoc="`pe`"
              :refId="payment.pe_id"
              :refCode="payment.pe_code"
              :showLog="getAccountSetting.log_topic.is_active"
              :showAttachFile="getAccountSetting.attach_file.is_active"
              :logTopics="getAccountSetting.log_topic.options"
              :isSubmitted="isSubmitted"
            />
          </template>
        </WrapperDoc>
      </template>
    </div>

    <div
      id="printModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-print-a4"
        role="document">
        <div class="modal-content">
          <div
            class="modal-body p-0"
            style="background: #C9CCCE;height: 660px;overflow: auto;">
            <printpe-view
              v-if="ready"
              :data="docInfo"
              :payment="payment"
              :form="form"
              class="print-template" />

          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-web"
              @click="onclickPrint()">{{ $t('button.print') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="closePrintModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel')
              }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal" />

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import printpeView from '@/components/apps/accounts/invoice/include/PrintPE.vue'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'
import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
const jwt = require('jsonwebtoken')
export default {
  name: 'AccountsPaymentEntryNew',
  components: {
    printpeView,
    WrapperDoc,
    DocRef,
  },
  mixins: [discardFormMixin, userPermissionMixin],

  data () {
    return {
      ready: false,

      formType: 'pay',

      form: {
        doc_type: '',
        doc_series: '',
        payment_type: 'cash',
        payment_amount: 0,
        payment_date: new Date(),
        note: '',
        ispaid: true,
      },

      originalForm: null,

      bindClass: {
        doc_type: '',
        doc_series: '',
        payment_amount: '',
      },

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      loadingPO: false,
      loadingEX: false,
      loadingIN: false,
      loadingPRL: false,

      isSubmitted: false,
    }
  },
  computed: {
    ...mapState('payroll', {
      payslip: 'paySlipSingle',
    }),
    ...mapGetters({
      sidebar: 'getSidebar',
      currency: 'getCurrency',
      dateformat: 'getDateFormat',
      payment: 'getPayment',
      purchase: 'getPurchase',
      expense: 'getExpense',
      invoice: 'getInvoice',
      getPaymentStatus: 'getPaymentStatus',
      getPurchaseStatus: 'getPurchaseStatus',
      getInvoiceStatus: 'getInvoiceStatus',
      getExpenseStatus: 'getExpenseStatus',
      getPurchaseInfo: 'getPurchaseInfo',
      getInvoiceInfo: 'getInvoiceInfo',
      getExpenseInfo: 'getExpenseInfo',
      getAccountSetting: 'getAccountSetting',
    }),
    isReadyToSave () {
      if (this.loadingPO || this.loadingEX || this.loadingIN || this.loadingPRL) {
        return false
      }
      return true
    },
    partnerInfo () {
      if (this.form.doc_type == 'po') {
        if (this.form.doc_series) {
          let po_id = this.form.doc_series
          let purchaseInfo = this.purchase
          return {
            vendor: purchaseInfo.vendor ? purchaseInfo.vendor : null,
          }
        }
      }
      if (this.form.doc_type == 'in') {
        if (this.form.doc_series) {
          let in_id = this.form.doc_series
          let invoiceInfo = this.invoice
          return {
            customer: invoiceInfo.customer ? invoiceInfo.customer : null,
          }
        }
      }
      return {}
    },
    docInfo () {
      if (this.form.doc_type == 'po') {
        if (this.form.doc_series) {
          return {
            po: this.purchase,
          }
        }
      }
      if (this.form.doc_type == 'ex') {
        if (this.form.doc_series) {
          return {
            ex: this.expense,
          }
        }
      }
      if (this.form.doc_type == 'in') {
        if (this.form.doc_series) {
          return {
            in: this.invoice,
          }
        }
      }
      if (this.form.doc_type == 'prl') {
        if (this.form.doc_series) {
          const prlId = this.form.doc_series
          return {
            prl: this.payslip,
          }
        }
      }
      return {}
    },
    sectionHeaderRefCode () {
      if (this.docInfo.po) {
        return this.docInfo.po.po_code
      }
      if (this.docInfo.ex) {
        return this.docInfo.ex.ex_code
      }
      if (this.docInfo.in) {
        return this.docInfo.in.in_code
      }
      if (this.docInfo.prl) {
        return this.docInfo.prl.prlCode
      }
      return null
    },
    reference_id () {
      if (!this.payment) {
        return null
      }
      if (this.payment.reference.purchase) {
        return { 'po_id': this.payment.reference.purchase.po_id }
      }
      if (this.payment.reference.invoice) {
        return { 'in_id': this.payment.reference.invoice.in_id }
      }
      if (this.payment.reference.expense) {
        return { 'ex_id': this.payment.reference.expense.ex_id }
      }
      if (this.payment.reference.payroll) {
        return { 'prl_id': this.payment.reference.payroll.prl_id }
      }
    },
    disabledForm () {
      return [
        'paid',
      ].includes(this.payment.status) || !this.hasRoleEdit
    },
  },
  methods: {
    ...mapActions('payroll', {
      getPaySlipSingle: 'getPaySlipSingle',
    }),
    onclickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    openPrintModal () {
      $('#printModal').modal('show')

      // set modal height
      $('#printModal .modal-body').css({
        height: window.innerHeight - 125 + 'px',
      })

      $('#printModal .modal-body').animate({ scrollTop: 0 }, 0)
    },
    closePrintModal () {
      $('#printModal').modal('hide')
    },
    isValid () {
      if (this.bindClass.doc_type == 'is-invalid' ||
         this.bindClass.doc_series == 'is-invalid' ||
         this.bindClass.payment_amount == 'is-invalid') {
        return false
      }
      return true
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    async update () {
      if (!this.isValid()) {
        return false
      }

      this.isSubmitted = true

      let dataSet = {
        'pe_id': this.payment.pe_id,
        'status': this.form.ispaid ? 'paid' : 'padding',
        'created_at': this.form.payment_date ? this.form.payment_date.toISOString() : this.moment().toISOString(),
        'note': this.form.note.trim().length > 0 ? this.form.note.trim() : null,
        'payment': {
          'type': this.form.payment_type,
          'amount': parseFloat(this.form.payment_amount),
        },
      }

      let res = await this.$store.dispatch('updatePayment', dataSet)

      if (res.success) {
        // get
        await this.$store.dispatch('getPayment', {
          pe_id: this.payment.pe_id,
        })
        // refresh document reference data such as po, ex, in
        await this.getDocRefData()
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.payment.pe_code }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    getDocInfo (payment) {
      if (payment.reference.purchase) {
        return {
          type: 'po',
          id: payment.reference.purchase.po_id,
          code: payment.reference.purchase.po_code,
        }
      } else if (payment.reference.expense) {
        return {
          type: 'ex',
          id: payment.reference.expense.ex_id,
          code: payment.reference.expense.ex_code,
        }
      } else if (payment.reference.invoice) {
        return {
          type: 'in',
          id: payment.reference.invoice.in_id,
          code: payment.reference.invoice.in_code,
        }
      } else if (payment.reference.payroll) {
        return {
          type: 'prl',
          id: payment.reference.payroll.prl_id,
          code: payment.reference.payroll.prl_code,
        }
      }
    },
    getFormType (payment) {
      if (this.getDocInfo(payment).type == 'po' || this.getDocInfo(payment).type == 'ex' || this.getDocInfo(payment).type == 'prl') {
        return 'pay'
      } else if (this.getDocInfo(payment).type == 'in') {
        return 'receive'
      }
    },
    setData () {
      let that = this
      let payment = this.payment
      let form = this.form

      this.formType = this.getFormType(payment)

      setTimeout(() => {
        // set form
        form.doc_type = that.getDocInfo(payment).type,
        form.doc_series = that.getDocInfo(payment).id,
        form.payment_type = payment.payment.type,
        form.payment_amount = this.setToCustomDigitsNumber(payment.payment.amount),
        form.payment_date = that.moment(payment.created_at).toDate(),
        form.note = payment.note || '',
        form.ispaid = payment.status == 'paid'
        // set originalForm
        that.originalForm = _.cloneDeep(this.form)
      }, 10)
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    async del () {
      let data = {
        'pe_id': this.payment.pe_id,
        'reference': this.reference_id,
      }

      let res = await this.$store.dispatch('deletePayment', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.payment.pe_code }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to
        return this.$router.push({ name: 'AccountsPaymentEntryAll' })
      }
    },
    async updatePaymentStatus (data) {
      this.isSubmitted = true

      let dataSet = {
        'pe_id': data.pe_id,
        'status': data.status,
        'reference': this.reference_id,
      }

      await this.$store.dispatch('updatePaymentStatus', dataSet)

      // show notify completed
      if (this.getPaymentStatus(this.payment, this.$t).status == 'completed') {
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencompleted', { msg: this.payment.pe_code }),
          color: 'success',
          icon: 'check',
        })
      }

      // show notify purchase completed
      if (this.docInfo.po) {
        // update payment status in purchase
        this.$store.dispatch('updatePurchasePaymentStatus', { pe_id: data.pe_id, status: data.status })
        // notify
        if (this.getPurchaseStatus(this.docInfo.po, this.$t, this.mixin).status == 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: that.docInfo.po.po_code }),
              color: 'success',
              icon: 'check',
            })
          }, 500)
        }
      }
      // show notify expense completed
      else if (this.docInfo.ex) {
        // update payment status in expense
        this.$store.dispatch('updateExpensePaymentStatus', { pe_id: data.pe_id, status: data.status })
        // notify
        if (this.getExpenseStatus(this.docInfo.ex, this.$t, this.mixin).status == 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: that.docInfo.ex.ex_code }),
              color: 'success',
              icon: 'check',
            })
          }, 500)
        }
      }
      // show notify invoice completed
      else if (this.docInfo.in) {
        // update payment status in invoice
        this.$store.dispatch('updateInvoicePaymentStatus', { pe_id: data.pe_id, status: data.status })
        // notify
        if (this.getInvoiceStatus(this.docInfo.in, this.$t, this.mixin).status == 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: that.docInfo.in.in_code }),
              color: 'success',
              icon: 'check',
            })
          }, 500)
        }
      }
      // show notify payslip completed
      else if (this.docInfo.prl) {
        await this.getPaySlipSingle(this.payment.reference.payroll.prl_id)
        if (this.payslip.process.debit === 0) {
          setTimeout(() => {
            this.notify(this.$vs, {
              text: this.$t('message.hasbeencompleted', { msg: this.docInfo.prl.prlCode }),
              color: 'success',
              icon: 'check',
            })
          }, 500)
        }
      }

      this.isSubmitted = false

      this.showFinish(this.$Progress)
    },
    async getDocRefData () {
      // get document reference
      if (this.payment.reference.purchase) {
        await this.$store.dispatch('getPurchase', {
          po_id: this.payment.reference.purchase.po_id,
        })
      } else if (this.payment.reference.expense) {
        await this.$store.dispatch('getExpense', {
          ex_id: this.payment.reference.expense.ex_id,
        })
      } else if (this.payment.reference.invoice) {
        await this.$store.dispatch('getInvoice', {
          in_id: this.payment.reference.invoice.in_id,
        })
      } else if (this.payment.reference.payroll) {
        await this.getPaySlipSingle(this.payment.reference.payroll.prl_id)
      }
    },

    async downloadPdf () {
      let data = {
        'type': 'pe',
        'lang': this.getLang,
        'id': this.payment.pe_id,
        'shop_id': this.auth.shop_info.shop_id,

      }

      let token = jwt.sign(data, this.project.config.token.secret, { expiresIn: this.project.config.token.download_pdf_expiresin })

      var link = document.createElement('a')
      // link.href = this.project.config.web.api_doc_gen_01 + 'file/pdf/' + token + '/' + this.invoice.in_code
      // link.href = this.project.config.web.doc + 'pdf/' + token + '/' + this.invoice.in_code
      link.href = this.project.config.web.api + 'file/pdf/' + token + '/' + this.payment.pe_code
      link.target = '_blank'
      link.dispatchEvent(new MouseEvent('click'))
    },

  },

  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    'form.payment_amount': {
      handler: function (after, before) {
        let val = parseFloat(after)
        if (isNaN(val)) {
          this.bindClass.payment_amount = 'is-invalid'
        } else {
          this.bindClass.payment_amount = ''
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    /**
     *  validation
     */
    if (!this.$route.query.pe_id) {
      return this.$router.push({ name: 'AccountsPaymentEntryAll' })
    }
    // get category
    let res = await this.$store.dispatch('getPayment', {
      pe_id: this.$route.query.pe_id,
    })
    if (!res.success) {
      return this.$router.push({ name: 'AccountsPaymentEntryAll' })
    }
    if (res.data.length == 0) {
      return this.$router.push({ name: 'AccountsPaymentEntryAll' })
    }
    /**
     *  validation success
     */
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // set data
    this.setData()
    // get document reference
    await this.getDocRefData()
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 3,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 2, [{
      'name': this.$route.query.pe_code,
      'router': {
        'name': 'AccountsPaymentEntryEdit',
        'query': {
          pe_id: this.$route.query.pe_id,
          pe_code: this.$route.query.pe_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 2,
      submenuAtIdx: 2,
    })
  },
  mounted: function () {
    // set popup modal
    this.setModal('#confirmdeleteModal')

    this.setModal('#printModal')
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearPayment', 'clearPurchase', 'clearExpense', 'clearInvoice'])
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/accounts/paymententry/Edit.vue